import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeaderView from './header-view';

class Header extends Component {
  render() {
    return (
      <HeaderView {...this.props} />
    )
  }
}

const mapStateToProps = (state) => ({
  layout: state.layout
});

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Header);




// WEBPACK FOOTER //
// ./src/components/layout/header.js